import React, { useState, FC, FocusEvent } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ListFieldProps } from '@sitecore-jss/sitecore-jss-react-forms'
import {
  UpdateConditionalFieldValue,
  UpdateShowSectionStatus,
} from '../../../ReduxImpl/actions/index'
import { DropdownListViewModel } from '@sitecore-jss/sitecore-jss-forms'
import { IReduxState } from '../../../ReduxImpl/reducers/index'

const Dropdownfield: FC<ListFieldProps<DropdownListViewModel>> = (props) => {
  const { field, tracker } = props

  const dispatch = useDispatch()

  const [hasFocus, setHasFocus] = useState(false)
  const [value, setDdlValue] = useState(props.value)

  const hasAnyError = !!props.errors?.length
  const hasValueOrFocus = hasFocus || value?.length !== 0

  var options = props.field.model.items.map((x, i) => (
    <option
      key={i}
      value={x.value}
      className="sitecore-jss-form__field--option"
    >
      {x.text}
    </option>
  ))

  if (field.model.showEmptyItem) {
    options.unshift(<option value=""></option>)
  }

  const label = field.model.title
  const id = field.valueField.id
  const name = field.valueField.name
  const FieldValidationErrors = props.fieldValidationErrorsComponent

  let fieldValues = useSelector((state: IReduxState) => state.fieldValues)

  const getCookieValue = (name) => {
    let result = document && document.cookie.match(
      '(^|[^;]+)\\s*' + name + '\\s*=\\s*([^;]+)'
    )
    return result ? result.pop() : ''
  }

  const onChange = (e: any): void => {
    const currentLang: string = e.target.value

    fieldValues[(field?.model?.['conditionSettings'] as any).fieldKey] = e.target.value

    if (field.model.name === 'LanguageDropdownList') {
      var d = new Date()
      d.setTime(d.getTime() + 5 * 24 * 60 * 60 * 1000)
      var expires = 'expires=' + d.toUTCString()

      document.cookie =
        'cnhicorporate#lang2=' + currentLang + ';path=/;' + expires

      window?.location?.reload()
      dispatch(UpdateShowSectionStatus(false))
    } else if ((field.model['conditionSettings'] as any).fieldKey in fieldValues) {
      if (field.model.name === 'LawUnderDropdownList' && e.target.value == '') {
        dispatch(UpdateShowSectionStatus(false))
      } else if (field.model.name !== 'CountryDropdownList') {
        dispatch(UpdateShowSectionStatus(true))
      }

      dispatch(UpdateConditionalFieldValue(fieldValues))
    }
    setDdlValue(e.target.value)

    props.onChange(field.valueField.name, e.target.value, props.isValid, [])
  }

  const onFocus = (e: FocusEvent<HTMLSelectElement>) => {
    tracker.onFocusField(field, e.target.value)
    setHasFocus(true)
  }

  const onBlur = (e: FocusEvent<HTMLSelectElement>) => {
    tracker.onBlurField(field, e.target.value)
    setHasFocus(false)
  }

  const getDropdownVal = () => {
    if (field.model.name === 'LanguageDropdownList') {
      return getCookieValue('cnhicorporate#lang2') || value
    }

    return value
  }

  return (
    <div
      className={`sitecore-jss-form__control sitecore-jss-form__control--text-box sitecore-jss-form__dropdown ${
        hasAnyError ? 'sitecore-jss-form__control--has-error' : ''
      } ${
        field.model.name === 'LanguageDropdownList'
          ? 'sitecore-jss-form__control--LanguageAlign'
          : ''
      }`}
    >
      {field.model.name === 'LanguageDropdownList' ? (
        <div> {label} </div>
      ) : (
        <label
          htmlFor={id}
          className={`sitecore-jss-form__label dropdownLabel ${
            hasValueOrFocus ? 'sitecore-jss-form__label--has-focus' : ''
          } `}
        >
          {label}
        </label>
      )}

      <select
        id={id}
        name={name}
        className={`sitecore-jss-form__field ${
          field.model.name === 'LawUnderDropdownList' ? 'lawdropdownWidth' : ''
        } ${
          field.model.name === 'LanguageDropdownList'
            ? 'languagedropdownStyle'
            : ''
        } `}
        onChange={onChange}
        value={getDropdownVal()}
        onFocus={onFocus}
        onBlur={onBlur}
      >
        {options}
      </select>

      {FieldValidationErrors && <FieldValidationErrors {...props} />}
    </div>
  )
}

export default Dropdownfield
